(() => {
  if (window.__sanearBitrixOnDemand) return;
  window.__sanearBitrixOnDemand = true;
  const attempts = new WeakMap();
  const strings = document.currentScript?.dataset || {};
  const selector = '[data-sanear-bitrix-form]';
  const near = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.target.isConnected) {
        near.unobserve(entry.target);
        load(entry.target);
      }
    });
  }, {rootMargin: '600px 0px'}) : null;

  function complete(host) {
    host.dataset.state = 'ready';
    host.setAttribute('aria-busy', 'false');
    host.querySelector('[data-sanear-bitrix-status]').hidden = true;
    attempts.get(host)?.observer?.disconnect();
  }

  function load(host) {
    if (!host || ['loading', 'ready'].includes(host.dataset.state)) return;
    const previous = attempts.get(host);
    if (host.dataset.state === 'error') {
      previous?.bootstrap?.remove();
      previous?.loader?.remove();
    }
    const original = host.querySelector('template[data-sanear-bitrix-bootstrap]')?.content.querySelector('script');
    if (!original) return;
    host.dataset.state = 'loading';
    host.setAttribute('aria-busy', 'true');
    const status = host.querySelector('[data-sanear-bitrix-status]');
    const retry = host.querySelector('[data-sanear-bitrix-retry]');
    status.textContent = host.dataset.loadingText;
    status.hidden = false;
    retry.hidden = true;
    const attempt = {};
    attempts.set(host, attempt);
    attempt.observer = new MutationObserver(() => {
      if (host.querySelector('form, iframe, input:not([type="hidden"]), select, textarea')) complete(host);
    });
    attempt.observer.observe(host, {childList: true, subtree: true});
    attempt.bootstrap = document.createElement('script');
    [...original.attributes].forEach(attribute => attempt.bootstrap.setAttribute(attribute.name, attribute.value));
    attempt.bootstrap.textContent = original.textContent;
    host.appendChild(attempt.bootstrap);
    attempt.loader = [...document.scripts].find(script => script.src.startsWith(host.dataset.loader));
    attempt.loader?.addEventListener('error', () => {
      if (host.dataset.state !== 'loading') return;
      host.dataset.state = 'error';
      host.setAttribute('aria-busy', 'false');
      status.textContent = host.dataset.errorText;
      retry.hidden = false;
      attempt.observer.disconnect();
    }, {once: true});
  }

  function bind(host) {
    if (host.dataset.bound) return;
    host.dataset.bound = 'true';
    host.dataset.loadingText ||= strings.sanearBitrixLoading || '';
    host.dataset.errorText ||= strings.sanearBitrixError || '';
    host.querySelector('[data-sanear-bitrix-status]').textContent = host.dataset.loadingText;
    host.querySelector('[data-sanear-bitrix-retry]').textContent ||= strings.sanearBitrixRetry || '';
    host.querySelector('[data-sanear-bitrix-retry]').addEventListener('click', () => load(host));
    if (host.dataset.requested === 'true') load(host);
    else if (host.dataset.trigger === 'near' && near) near.observe(host);
  }

  function scan(root = document) {
    if (root.matches?.(selector)) bind(root);
    root.querySelectorAll(selector).forEach(bind);
    if (!near) checkNearby();
  }

  function checkNearby() {
    document.querySelectorAll(selector+'[data-trigger="near"]').forEach(host => {
      const bounds = host.getBoundingClientRect();
      if (bounds.bottom >= -600 && bounds.top <= window.innerHeight + 600) load(host);
    });
  }

  document.addEventListener('sanear:bitrix-request', event => {
    const host = event.target.closest?.(selector);
    if (host) {
      bind(host);
      load(host);
    }
  });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(host => {
      near?.unobserve(host);
      attempts.get(host)?.observer?.disconnect();
    });
  });
  if (!near) {
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        checkNearby();
      });
    };
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once: true});
  else scan();
})();

